import type { PropsWithChildren } from "react"

import svgLogo from "common/assets/logo.svg"

export const ErrorLayout = ({ children }: PropsWithChildren<{}>) => (
  <div className="mx-auto flex max-w-xl flex-col items-center">
    <img alt="The Conversation" className="py-8 px-2" src={svgLogo} width="483" height="61" />
    {children}
  </div>
)
